"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_STOCKTAKE = void 0;
var SINGLE_STOCKTAKE = {
  ROW__STOCKTAKE_ITEM: 'singleStocktake-tr-stocktakeItem',
  BUTTON__EXPORT: 'singleStocktake-button-exportCSV',
  TEXT__USER: 'singleStocktake-span-user',
  TEXT__PRODUCT_NAME: 'singleStocktake-span-productName',
  TEXT__PRODUCT_SKU: 'singleStocktake-span-productSKU',
  TEXT__LOCATION: 'singleStocktake-span-location',
  TEXT__BATCH_CODE: 'singleStocktake-span-batchCode',
  TEXT__EXPIRY_DATE: 'singleStocktake-span-expiryDate',
  TEXT__PRIOR_STOCK: 'singleStocktake-span-priorStock',
  TEXT__ACTUAL_STOCK: 'singleStocktake-span-actualStock',
  TEXT__ORDERING_UNIT: 'singleStocktake-span-orderingUnit',
  TEXT__COGS: 'singleStocktake-span-cogs',
  TEXT__DIFFERENCE: 'singleStocktake-span-difference',
  TEXT__NOTE: 'singleStocktake-span-note'
};
exports.SINGLE_STOCKTAKE = SINGLE_STOCKTAKE;